module.exports = __webpack_public_path__ + "static/38import-ef337924c6a1c84dc9d058078854166e.png";